import { ImageFolderEnum } from '@/models/CkEditor';
import ConditionalRenderer from '../ConditionalRenderer';
import MyCkeditor from '@/components/editor/MyCkeditor';

type CkEditorInputProps = {
  label: string;
  error?: string;
  value: string;
  onChange: (value: string) => void;
  folder: ImageFolderEnum;
  testId: string;
};

export default function CkEditorInput({
  label,
  error,
  value,
  onChange,
  folder,
  testId,
}: CkEditorInputProps) {
  return (
    <div className="flex flex-col">
      <label
        htmlFor={testId}
        className="label leading-none p-0 w-full text-[0.875rem]"
      >
        {label}
      </label>
      <ConditionalRenderer condition={error}>
        <label className="font-rubik text-error error-label text-[0.875rem]">
          {error}
        </label>
      </ConditionalRenderer>
      <MyCkeditor
        testId={testId}
        content={value || ''}
        folder={folder}
        handleContentChange={onChange}
      />
    </div>
  );
}
